export default (state = [], action) => {
  let { type, payload } = action
  switch (type) {
    case 'PRIVATE_LAND_PAYLOAD':
      return payload
    case 'PRIVATE_LAND_PAYLOAD_REMOVE':
      return []
    case 'LOGOUT':
      return []
    default:
      return state
  }
}
